import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import FinanceCardChart from "../financeCardChart/financeCardChart";
import InfoIcon from "../../../assets/icons/info-icon.svg";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const FinanceDebtsPeriod = ({ delinquencyPeriod, dateRange = null, code }) => {
  const [showPopover, setShowPopover] = useState(false);
  const [showDataModal, setShowDataModal] = useState(false);
  const [clickedPeriod, setClickedPeriod] = useState(null);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();
  
  console.log('overdue30To60DaysPercentage', delinquencyPeriod)
  const data = {
    labels: ["Categorias"],
    datasets: [
      {
        label: "Até 30 dias",
        data: [delinquencyPeriod?.overdueLast30DaysPercentage],
        backgroundColor: "#0962AD"
      },
      {
        label: "Entre 30 e 60 dias",
        data: [delinquencyPeriod?.overdue30To60DaysPercentage],
        backgroundColor: "#2BAD70"
      },
      {
        label: "Entre 60 e 90 dias",
        data: [delinquencyPeriod?.overdue60To90DaysPercentage],
        backgroundColor: "#E4C566"
      },
      {
        label: "Acima de 90 dias",
        data: [delinquencyPeriod?.overdueAbove90DaysPercentage],
        backgroundColor: "#DA5252"
      }
    ]
  };

  const handleChartClick = (event, elements) => {
    if (elements && elements.length > 0) {
      const clickedElement = elements[0];
      const datasetIndex = clickedElement.datasetIndex;
      
      const periods = [
        { label: "Até 30 dias", days: 30, type: "last30" },
        { label: "Entre 30 e 60 dias", days: 60, type: "30to60" },
        { label: "Entre 60 e 90 dias", days: 90, type: "60to90" },
        { label: "Acima de 90 dias", days: 91, type: "above90" }
      ];
      
      const selectedPeriod = periods[datasetIndex];
      
      setClickedPeriod(selectedPeriod);
      setModalPosition({
        x: event.native.clientX,
        y: event.native.clientY
      });
      setShowDataModal(true);
    }
  };

  const handleNavigateToData = () => {
    if (!clickedPeriod || !dateRange || !dateRange.to) {
      setShowDataModal(false);
      return;
    }
    
    const params = new URLSearchParams();
    params.set('page', '1');
    params.set('filterId', 'b9d25bf5-33f0-4433-a4ba-548f0c78a542');
    
    const endDate = new Date(dateRange.to);
    let startDateForFilter, endDateForFilter;
    
    // Calcular as datas baseado no período clicado
    switch (clickedPeriod.type) {
      case "last30":
        // Até 30 dias: entre (endDate - 30 dias) e endDate
        startDateForFilter = new Date(endDate);
        startDateForFilter.setDate(startDateForFilter.getDate() - 30);
        endDateForFilter = new Date(endDate);
        break;
        
      case "30to60":
        // Entre 30 e 60 dias: entre (endDate - 60 dias) e (endDate - 30 dias)
        startDateForFilter = new Date(endDate);
        startDateForFilter.setDate(startDateForFilter.getDate() - 60);
        endDateForFilter = new Date(endDate);
        endDateForFilter.setDate(endDateForFilter.getDate() - 30);
        break;
        
      case "60to90":
        // Entre 60 e 90 dias: entre (endDate - 90 dias) e (endDate - 60 dias)
        startDateForFilter = new Date(endDate);
        startDateForFilter.setDate(startDateForFilter.getDate() - 90);
        endDateForFilter = new Date(endDate);
        endDateForFilter.setDate(endDateForFilter.getDate() - 60);
        break;
        
      case "above90":
        // Acima de 90 dias: antes de (endDate - 90 dias)
        // Usar uma data bem antiga como início
        startDateForFilter = new Date(endDate);
        startDateForFilter.setFullYear(startDateForFilter.getFullYear() - 10);
        endDateForFilter = new Date(endDate);
        endDateForFilter.setDate(endDateForFilter.getDate() - 90);
        break;
        
      default:
        setShowDataModal(false);
        return;
    }
    
    // Formatar as datas no formato DD-MM-YYYY
    const formatDate = (date) => {
      return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    };
    
    params.set('startDate', formatDate(startDateForFilter));
    params.set('endDate', formatDate(endDateForFilter));
    
    console.log('Navegando para período de inadimplência:', {
      period: clickedPeriod.label,
      startDate: formatDate(startDateForFilter),
      endDate: formatDate(endDateForFilter)
    });
    
    navigate(`/app/dados-consolidados?${params.toString()}`);
    setShowDataModal(false);
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: handleChartClick,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxHeight: 6,
          color: "#858585",
          font: { size: 14 }
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`
        }
      }
    },
    scales: {
      y: {
        grid: {
          color: "#D2D5DA"
        },
        border: {
          dash: [2, 4]
        },
        ticks: {
          callback: function (value) {
            return value;
          }
        }
      }
    }
  };

  return (
    <>
      <FinanceCardChart
        code={code}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>Período de Inadimplência</span>
            <div style={{ position: 'relative' }}>
              <img
                src={InfoIcon}
                alt="Informação"
                onClick={() => setShowPopover(!showPopover)}
                style={{
                  width: '14px',
                  height: '14px',
                  cursor: 'pointer',
                  verticalAlign: 'middle',
                  display: 'inline-block',
                }}
              />
              {showPopover && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "100%",
                    transform: "translate(0, -50%)",
                    marginLeft: "8px",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    padding: "10px",
                    zIndex: 100,
                    width: "220px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "4px"
                  }}
                >
                  <p style={{ margin: 0, fontSize: "12px", fontWeight: "normal" }}>
                    As faixas de inadimplência separam alunos com parcelas vencidas em até 30 dias, entre 31 e 90 dias e acima de 90 dias, calculando a % de cada grupo sobre o total de alunos únicos no período.
                  </p>
                  <button
                    onClick={() => setShowPopover(false)}
                    style={{
                      marginTop: "8px",
                      fontSize: "10px",
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                      color: "#0962AD"
                    }}
                  >
                    Fechar
                  </button>
                </div>
              )}
            </div>
          </div>
        }
      >
        <Bar data={data} options={options} />
      </FinanceCardChart>

      {showDataModal && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999
            }}
            onClick={() => setShowDataModal(false)}
          />
          <div
            style={{
              position: "fixed",
              top: modalPosition.y + 10,
              left: modalPosition.x - 100,
              backgroundColor: "#fff",
              padding: "12px 16px",
              borderRadius: "6px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
              border: "1px solid #e0e0e0",
              zIndex: 1000,
              minWidth: "200px",
              maxWidth: "250px"
            }}
          >
            <p style={{ margin: "0 0 12px 0", fontSize: "13px", color: "#333", fontWeight: "500" }}>
              Inadimplentes - {clickedPeriod?.label || ''}
            </p>
            <button
              onClick={handleNavigateToData}
              style={{
                width: "100%",
                padding: "6px 12px",
                fontSize: "13px",
                cursor: "pointer",
                backgroundColor: "#0962AD",
                border: "none",
                borderRadius: "4px",
                color: "#fff"
              }}
            >
              Ver dados consolidados
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default FinanceDebtsPeriod;
